import i18n from 'ar-i18n';
import { browserHistory } from 'react-router';
import moment from 'moment';
import cookie from 'cookie-cutter';
import _ from 'lodash';
import Raven from 'raven-js';

import {getConversionDataCutoffDate, filterByCutoffDate} from './utils/dates.js';
import { isBudgetLow } from './utils/budget';

// Consts to export
export const I18N_LOADED = 'I18N_LOADED';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const RECEIVE_USERNAME = 'RECEIVE_USERNAME';
export const RECEIVE_ADVERTISABLE_EID = 'RECEIVE_ADVERTISABLE_EID';
export const RECEIVE_SHOP_ID = 'RECEIVE_SHOP_ID';
export const RECEIVE_EXTERNAL_SHOP_ID = 'RECEIVE_EXTERNAL_SHOP_ID';
export const RECEIVE_SHOP_NAME = 'RECEIVE_SHOP_NAME';
export const RECEIVE_MERCHANT_DASH_ALLOWED = 'RECEIVE_MERCHANT_DASH_ALLOWED';
export const RECEIVE_READ_ONLY_USER = 'RECEIVE_READ_ONLY_USER';
export const RECEIVE_NOTIFICATIONS = 'RECEIVE_NOTIFICATIONS ';
export const RECEIVE_STRATEGY = 'RECEIVE_STRATEGY';
export const RECEIVE_AGGREGATE_PERFORMANCE = 'RECEIVE_AGGREGATE_PERFORMANCE';
export const RECEIVE_MONTH_TO_DATE_PERFORMANCE = 'RECEIVE_MONTH_TO_DATE_PERFORMANCE';
export const RECEIVE_AGGREGATE_ATTRIBUTIONS = 'RECEIVE_AGGREGATE_ATTRIBUTIONS';
export const SET_DAILY_PERFORMANCE = 'SET_DAILY_PERFORMANCE';
export const RECEIVE_DAILY_ATTRIBUTIONS = 'RECEIVE_DAILY_ATTRIBUTIONS';
export const FINISHED_LOADING_NOTIFICATIONS = 'FINISHED_LOADING_NOTIFICATIONS';
export const FINISHED_LOADING_STRATEGY = 'FINISHED_LOADING_STRATEGY';
export const UPDATE_STRATEGY = 'UPDATE_STRATEGY';
export const SAVE_STRATEGY_SUCCESS = 'SAVE_STRATEGY_SUCCESS';
export const SAVE_STRATEGY_FAILED = 'SAVE_STRATEGY_FAILED';
export const PAUSE_STRATEGY_SUCCESS = 'PAUSE_STRATEGY_SUCCESS';
export const PAUSE_STRATEGY_FAILED = 'PAUSE_STRATEGY_FAILED';
export const RESUME_STRATEGY_SUCCESS = 'RESUME_STRATEGY_SUCCESS';
export const RESUME_STRATEGY_FAILED = 'RESUME_STRATEGY_FAILED';
export const FETCH_AGGREGATE_PERFORMANCE_FAILED = 'FETCH_AGGREGATE_PERFORMANCE_FAILED';
export const FETCH_MONTH_TO_DATE_PERFORMANCE_FAILED = 'FETCH_MONTH_TO_DATE_PERFORMANCE_FAILED';
export const ACTIVATE_MONTHLY_BUDGET_CAP_VALIDATION = 'ACTIVATE_MONTHLY_BUDGET_CAP_VALIDATION';
export const FETCH_DAILY_PERFORMANCE_FAILED = 'FETCH_DAILY_PERFORMANCE_FAILED';
export const FETCH_DAILY_ATTRIBUTIONS_FAILED = 'FETCH_DAILY_ATTRIBUTIONS_FAILED';
export const FETCH_AGGREGATE_ATTRIBUTIONS_FAILED = 'FETCH_AGGREGATE_ATTRIBUTIONS_FAILED';
export const SET_REPORTING_START_DATE = 'SET_REPORTING_START_DATE';
export const SET_REPORTING_END_DATE = 'SET_REPORTING_END_DATE';
export const SET_REPORTING_SORT = 'SET_REPORTING_SORT';
export const SHOW_SAVE_MODAL = 'SHOW_SAVE_MODAL';

// status of strategy
export const STATUS_PENDING_CREATE = 'pending_create';
export const STATUS_CREATED = 'created';
export const STATUS_LIVE = 'live';
export const STATUS_CREATING = 'creating';
export const STATUS_PENDING_EDIT = 'pending_edit';
export const STATUS_EDITING = 'editing';
export const STATUS_IN_LIMBO = 'in_limbo';
export const STATUS_TROUBLED = 'troubled';
export const STATUS_PAUSED = 'paused';
export const STATUS_REJECTED = 'rejected';

// recommended budget
export const FETCH_RECOMMENDED_BUDGET_FAILED = 'FETCH_RECOMMENDED_BUDGET_FAILED';
export const RECEIVE_RECOMMENDED_BUDGET = 'RECEIVE_RECOMMENDED_BUDGET';
export const SHOW_RECOMMENDED_BUDGET = 'SHOW_RECOMMENDED_BUDGET';

// constants used to create strategy using voltron API
export const BUDGET_FREQUENCY = 'daily';
export const CURRENCY = 'JPY';
export const GOAL = 'sales';
export const KPI_METRIC = 'CPC';
export const PRODUCTS = 'web,fb';
export const TEMPLATE = 'rakuten';

export const STRATEGY_ACTIVE_STATUSES = [
    STATUS_PENDING_CREATE,
    STATUS_CREATING,
    STATUS_CREATED,
    STATUS_LIVE,
    STATUS_PENDING_EDIT,
    STATUS_EDITING,
    STATUS_IN_LIMBO,
    STATUS_TROUBLED
];

export const STRATEGY_INACTIVE_STATUSES = [
    STATUS_PAUSED, STATUS_REJECTED
];

const LOCALE = process.env.DEFAULT_LOCALE;
const i18nPath = `${process.env.STATIC_PATH}/i18n`;
const CATALOG_URL = unescape(`${i18nPath}/${LOCALE}${process.env.CATALOG_FILE}`);
const CSRF_TOKEN_HEADER_NAME = 'X-CSRF-Token';
const CSRF_TOKEN_COOKIE_NAME = 'csrftoken';
const ENVIRONMENT = process.env.ENVIRONMENT || 'development';


Raven.config('https://33cfd6f6420248dca138a758aaa8b4ad@sentry.io/109215',
    {
        environment: ENVIRONMENT,
        debug: ENVIRONMENT === 'development',
        shouldSendCallback: function() {
            return ENVIRONMENT !== 'development';
        }
    }
).install();


function i18nLoadedAction(value) {
    return {
        type: I18N_LOADED,
        value: value
    };
}

function receiveShopId(value) {
    return {
        type: RECEIVE_SHOP_ID,
        value: value
    };
}

function receiveExternalShopId(value) {
    return {
        type: RECEIVE_EXTERNAL_SHOP_ID,
        value: value
    };
}

function receiveShopName(value) {
    return {
        type: RECEIVE_SHOP_NAME,
        value: value
    };
}

function receiveMerchantDashAllowed(value) {
    return {
        type: RECEIVE_MERCHANT_DASH_ALLOWED,
        value: value
    };
}

function receiveReadOnlyUser(value) {
    switch(value) {
        case 'true':
            value = true;
            break;
        case 'false':
            value = false;
            break;
        default:
            break;
    }

    return {
        type: RECEIVE_READ_ONLY_USER,
        value: value
    };
}

function receiveUsername(value) {
    return {
        type: RECEIVE_USERNAME,
        value: value
    };
}

function receiveAdvertisableEid(value) {
    return {
        type: RECEIVE_ADVERTISABLE_EID,
        value: value
    };
}

function finishedLoadingNotifications() {
    return {
        type: FINISHED_LOADING_NOTIFICATIONS
    };
}

function finishedLoadingStrategy() {
    return {
        type: FINISHED_LOADING_STRATEGY
    };
}

export function receiveNotifications(value) {
    return {
        type: RECEIVE_NOTIFICATIONS,
        value: value
    };
}

export function dismissNotification(displayOrder) {
    return {
        type: DISMISS_NOTIFICATION,
        displayOrder: displayOrder
    };
}

export function receiveStrategy(value) {
    return {
        type: RECEIVE_STRATEGY,
        value: value
    };
}

function setReportingSortAction(value) {
    return {
        type: SET_REPORTING_SORT,
        value: value
    };
}

export function updateStrategy(value) {
    return {
        type: UPDATE_STRATEGY,
        value: value
    };
}

export function setReportingStartDate(value) {
    return {
        type: SET_REPORTING_START_DATE,
        value: value
    };
}

export function setReportingEndDate(value) {
    return {
        type: SET_REPORTING_END_DATE,
        value: value
    };
}

export function saveStrategySuccess(value) {
    return {
        type: SAVE_STRATEGY_SUCCESS,
        value: value
    };
}

export function saveStrategyFailed() {
    return {
        type: SAVE_STRATEGY_FAILED
    };
}

export function pauseStrategySuccess(value) {
    return {
        type: PAUSE_STRATEGY_SUCCESS,
        value: value
    };
}

export function resumeStrategySuccess(value) {
    return {
        type: RESUME_STRATEGY_SUCCESS,
        value: value
    };
}

function receiveAggregatePerformance(value) {
    return {
        type: RECEIVE_AGGREGATE_PERFORMANCE,
        value: value
    };
}

export function receiveMonthToDatePerformance(value) {
    return {
        type: RECEIVE_MONTH_TO_DATE_PERFORMANCE,
        value: value
    };
}

export function activateMonthlyBudgetCapValidation(value) {
    return {
        type: ACTIVATE_MONTHLY_BUDGET_CAP_VALIDATION,
        value: value
    };
}

function setDailyPerformance(value) {
    return {
        type: SET_DAILY_PERFORMANCE,
        value: value
    };
}

function receiveDailyAttributions(value) {
    return {
        type: RECEIVE_DAILY_ATTRIBUTIONS,
        value: value
    };
}

function receiveAggregateAttributions(value) {
    return {
        type: RECEIVE_AGGREGATE_ATTRIBUTIONS,
        value: value
    };
}

function receiveRecommendedBudget(value) {
    return {
        type: RECEIVE_RECOMMENDED_BUDGET,
        value: value
    };
}

export function showRecommendedBudget(value) {
    return {
        type: SHOW_RECOMMENDED_BUDGET,
        value: value
    };
}

function redirectToLoginErrorPage() {
    window.location.assign(`${process.env.RAKUTEN_LOGIN_ERROR_PAGE_URL}`);
}

export function initi18n() {
    return (dispatch, getState) => {
        const {i18nLoaded} = getState();
        if (!i18nLoaded) {
            if (ENVIRONMENT !== 'production') {
                if(window.location.search.search('english=true') >= 0) {
                    // Short circuit when english=true and we're not in prod...
                    dispatch(i18nLoadedAction(true));
                    return;
                }
            }
            i18n.init(CATALOG_URL, process.env.I18N_DOMAIN);
            i18n.fetchMessages(LOCALE, err => {
                if (!err) {
                    i18n.setLocale('ja_JP');
                    dispatch(i18nLoadedAction(true));
                }
            });
        }
    };
}

export function requestWhoAmI() {
    return (dispatch, getState) => {
        const {advertisableEid} = getState();
        if (advertisableEid) {
            return Promise.resolve();
        }
        return window.fetch(`${process.env.API_URL}/account/sso/rakuten/whoami`, {credentials: 'include'})
            .then(response => checkStatus(response, 'Failed to get whoami'))
            .then(response => {
                if (response.status >= 400) {
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (typeof response === 'undefined' || response === null) {
                    // the user becomes unauthenticated, we need remove the context data.
                    Raven.setUserContext();
                    redirectToLoginErrorPage();
                    return;
                }
                if (response && typeof(response) === 'object') { // It's the new API; otherwise, bail
                    // Add user context to Sentry to make it easier to debug/reproduce the issue.
                    Raven.setUserContext({
                        advertisable_eid: response.advertisable_eid
                    });
                    dispatch(receiveAdvertisableEid(response.advertisable_eid));
                    dispatch(receiveUsername(response.username));
                    dispatch(receiveShopId(response.shop_id));
                    dispatch(receiveMerchantDashAllowed(response.merchant_dash_allowed));
                    dispatch(fetchNotifications(response.advertisable_eid));
                    dispatch(receiveExternalShopId(response.external_shop_id));
                    dispatch(receiveShopName(response.shop_name));
                    dispatch(receiveReadOnlyUser(response.readonly || false));
                }
            }).catch(function(error) {
                Raven.captureException(error);
            });
    };
}

function _getJsonPostHeaders() {
    return {
        'Content-Type': 'application/json',
        [CSRF_TOKEN_HEADER_NAME]: cookie.get(CSRF_TOKEN_COOKIE_NAME)
    };
}

function _getFormPostHeaders() {
    return {
        [CSRF_TOKEN_HEADER_NAME]: cookie.get(CSRF_TOKEN_COOKIE_NAME)
    };
}

// If campaignJson has 'eid', Voltron will update the strategy. Otherwise, a new strategy will be created.
export function saveCampaign(campaignJson) {
    return (dispatch) => {
        return window.fetch(`${process.env.API_URL}/activate/api/advertisable/${campaignJson.advertisable_eid}/strategies`, {
                method: 'POST',
                credentials: 'include',
                headers: _getJsonPostHeaders(),
                body: JSON.stringify(campaignJson)
            })
            .then(response => checkStatus(response, 'Failed to save the campaign'))
            .then(response => {
                if (response.status === 403) {
                    redirectToLoginErrorPage();
                    return null;
                }
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch(saveStrategyFailed());
                    return null;
                }
                return response.json();
            }).then(response => {
                if (response && typeof(response) === 'object' && response.status === 200) {
                    dispatch(saveStrategySuccess(response.data));
                    dispatch(redirectToRoute(`${process.env.ROOT_PATH}dashboard`));
                }
            }).catch(function (error) {
                dispatch(saveStrategyFailed());
                Raven.captureException(error);
            });
    };
}

export function pauseCampaign(advertisableEid, strategyEid) {
    return (dispatch) => {
        return window.fetch(`${process.env.API_URL}/activate/api/advertisable/${advertisableEid}/strategies/${strategyEid}/pause`, {
                method: 'POST',
                headers: _getJsonPostHeaders(),
                credentials: 'include'
            })
            .then(response => checkStatus(response, 'Failed to pause the campaign'))
            .then(response => {
                if (response.status === 403) {
                    redirectToLoginErrorPage();
                    return null;
                }
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch({type: PAUSE_STRATEGY_FAILED});
                    return null;
                }
                return response.json();
            }).then(response => {
                if (response && typeof(response) === 'object' && response.status === 200) {
                    dispatch(pauseStrategySuccess(response.data));
                    dispatch(redirectToRoute(`${process.env.ROOT_PATH}dashboard`));
                }
            }).catch(function (error) {
                dispatch({type: PAUSE_STRATEGY_FAILED});
                Raven.captureException(error);
            });
    };
}

export function resumeCampaign(advertisableEid, strategyEid, endDate) {
    return (dispatch) => {
        return window.fetch(`${process.env.API_URL}/activate/api/advertisable/${advertisableEid}/strategies/${strategyEid}/resume`, {
                method: 'POST',
                credentials: 'include',
                headers: _getJsonPostHeaders(),
                body: JSON.stringify({end_date: endDate})
            })
            .then(response => checkStatus(response, 'Failed to resume the campaign'))
            .then(response => {
                if (response.status === 403) {
                    redirectToLoginErrorPage();
                    return null;
                }
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch({type: RESUME_STRATEGY_FAILED});
                    return null;
                }
                return response.json();
            }).then(response => {
                if (response && typeof(response) === 'object' && response.status === 200) {
                    dispatch(resumeStrategySuccess(response.data));
                    dispatch(redirectToRoute(`${process.env.ROOT_PATH}dashboard`));
                }
            }).catch(function (error) {
                dispatch({type: RESUME_STRATEGY_FAILED});
                Raven.captureException(error);
            });
    };
}

export function fetchStrategyForAdvertisable() {
    return (dispatch, getState) => {
        const { recommendedBudget } = getState();
        return dispatch(requestWhoAmI())
            .then(() => {
                const {advertisableEid, merchantDashAllowed} = getState();
                // if this merchant is not allowed to access dash, so do not even try to pull the strategy.
                if (!merchantDashAllowed) {
                    return null;
                }
                return window.fetch(`${process.env.API_URL}/activate/api/advertisable/${advertisableEid}/strategies/get_rakuten_strategy`, {credentials: 'include'});
            })
            .then(response => {
                if (response !== null) {
                    response = checkStatus(response, 'Failed to fetch the strategy');
                }
                return response;
            })
            .then(response => {
                if (response === null || response.status === 404 || response.url.endsWith('404')) {
                    dispatch(finishedLoadingStrategy());
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (response && typeof(response) === 'object') {
                    const strategy = response.data;
                    if (!_.isEmpty(strategy)) {
                        dispatch(receiveStrategy(strategy));
                    }
                    if (!recommendedBudget || (recommendedBudget.ui_state && recommendedBudget.ui_state.fetch_recommended_budget_failed)) {
                        dispatch(fetchRecommendedBudget());
                    } else {
                        const weeklyBudget = strategy.weekly_budget || 0;
                        const dailyBudget = _.round(weeklyBudget / 7.0, 0);
                        if(isBudgetLow(dailyBudget, recommendedBudget)) {
                            dispatch(showRecommendedBudget(true));
                        } else {
                            dispatch(showRecommendedBudget(false));
                        }
                    }
                }
                dispatch(finishedLoadingStrategy());
            }).catch(function(error) {
                Raven.captureException(error);
            });
    };
}

export function fetchRecommendedBudget() {
    return (dispatch, getState) => {
        const { externalShopId, strategy  } = getState();
            return window.fetch(`${process.env.API_URL}/rakuten/api/v1/budget_recommendations?shop_id=${externalShopId}`, {credentials: 'include'})
                .then(response => {
                    if (response !== null) {
                        response = checkStatus(response, `Failed to fetch the recommended budget for ${externalShopId}`);
                    }
                    return response;
                })
                .then(response => {
                    if (response === null || response.status === 404) {
                        dispatch({type: FETCH_RECOMMENDED_BUDGET_FAILED});
                        return null;
                    }
                    return response.json();
                })
                .then(response => {
                    if (response && typeof(response) === 'object' && response.status === 200 && !_.isEmpty(response.data)) {
                        const budgetRecommendation = response.data.budget_recommendation;
                        const weeklyBudget = strategy && strategy.weekly_budget ? strategy.weekly_budget : 0;
                        dispatch(receiveRecommendedBudget(budgetRecommendation));
                        const dailyBudget = _.round(weeklyBudget / 7.0, 0);
                        if(isBudgetLow(dailyBudget, budgetRecommendation)) {
                            dispatch(showRecommendedBudget(true));
                        }
                    }
                }).catch(function(error) {
                    Raven.captureException(error);
                });
    };
}

export function redirectToRoute(route) {
    return () => browserHistory.push(route);
}

export function fetchAggregatePerformance() {
    return (dispatch, getState) => {
        const {strategy, reportingStartDate, reportingEndDate} = getState();
        let today = moment.utc().startOf('day');
        // Uhura's end date is exclusive while the one in UI is inclusive, so we need increment the one from UI by one.
        let actualEndDate = moment.utc(reportingEndDate).add(1, 'days');
        if (reportingStartDate.isAfter(today) || reportingStartDate.isSameOrAfter(actualEndDate)) {
           return  dispatch(receiveAggregatePerformance({}));
        }
        return window.fetch(`${process.env.API_URL}/rakuten/api/v1/deliveries?start_date=${i18n.moment(reportingStartDate).format('YYYY-MM-DD')}&end_date=${i18n.moment(actualEndDate).format('YYYY-MM-DD')}&advertisable_eid=${strategy.advertisable_eid}`,
                            {credentials: 'include'})
            .then(response => checkStatus(response, 'Failed to fetch aggregate performance'))
            .then(response => {
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch({type: FETCH_AGGREGATE_PERFORMANCE_FAILED});
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (response) {
                    let cutoffDate = getConversionDataCutoffDate(); // get cutoff date that we will use to filter out rows
                    let rows = response.data.date; // date is an array
                    let validRows = filterByCutoffDate(rows, cutoffDate);

                    // now use the remaining rows to produce a summary
                    let summary = {
                        spend: 0,
                        clicks: 0,
                        impressions: 0
                    };

                    let maskDate = new Date(Date.UTC(2019, 6, 1, 0, 0, 0));

                    validRows.forEach(row => {
                        row.date = new Date(row.date);
                        if (row.date >= maskDate) {
                            row.cost = 0;
                            row.impressions = 0;
                            row.clicks = 0;
                        }
                        summary.spend += row.cost;
                        summary.clicks += row.clicks;
                        summary.impresssions += row.impresssions;
                    });

                    dispatch(receiveAggregatePerformance(summary));
                }
            }).catch(function(error) {
                Raven.captureException(error);
            });
    };
}

export function fetchDailyPerformance() {
    return (dispatch, getState) => {
        const { strategy, reportingStartDate, reportingEndDate } = getState();
        let today = moment.utc().startOf('day');
        // Uhura's end date is exclusive while the one in UI is inclusive, so we need increment the one from UI by one.
        let actualEndDate = moment.utc(reportingEndDate).add(1, 'days');
        if (reportingStartDate.isAfter(today) || reportingStartDate.isSameOrAfter(actualEndDate)) {
            return dispatch(setDailyPerformance([]));
        }
        return window.fetch(`${process.env.API_URL}/rakuten/api/v1/deliveries?start_date=${i18n.moment(reportingStartDate).utc().format('YYYY-MM-DD')}&end_date=${i18n.moment(actualEndDate).utc().format('YYYY-MM-DD')}&advertisable_eid=${strategy.advertisable_eid}`,
                            {credentials: 'include'})
            .then(response => checkStatus(response, 'Failed to fetch daily performance'))
            .then(response => {
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch({type: FETCH_DAILY_PERFORMANCE_FAILED});
                    dispatch(setDailyPerformance([]));
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (response) {
                    let results = [];
                    for (let i in response.data.date) {
                        let maskDate = new Date(Date.UTC(2019, 6, 1, 0, 0, 0));

                        response.data.date[i].date = new Date(response.data.date[i].date);
                        response.data.date[i].eid = response.data.date[i].date.getTime().toString();
                        if (response.data.date[i].date < maskDate) {
                            response.data.date[i].spend = response.data.date[i].cost;
                        } else {
                            response.data.date[i].spend = 0;
                            response.data.date[i].impressions = 0;
                            response.data.date[i].clicks = 0;
                        }

                        results.push(response.data.date[i]);
                    }

                    dispatch(setDailyPerformance(results));
                    dispatch(sortDailyPerformance());
                }
            }).catch(function(error) {
                Raven.captureException(error);
            });
    };
}

export function fetchMonthToDatePerformance() {
    return (dispatch, getState) => {
        const {strategy} = getState();

        if (!strategy || !strategy.advertisable_eid) {
            return Promise.resolve(dispatch(receiveMonthToDatePerformance({
                spend: 0,
                clicks: 0,
                impressions: 0
            })));
        }

        let reportingStartDate = moment.utc().startOf('month');
        let reportingEndDate = moment.utc().startOf('day');
        // Uhura's end date is exclusive while the one in UI is inclusive, so we need increment the one from UI by one.
        let actualEndDate = moment.utc(reportingEndDate).add(1, 'days');

        return window.fetch(`${process.env.API_URL}/rakuten/api/v1/deliveries?start_date=${i18n.moment(reportingStartDate).format('YYYY-MM-DD')}&end_date=${i18n.moment(actualEndDate).format('YYYY-MM-DD')}&advertisable_eid=${strategy.advertisable_eid}`,
                            {credentials: 'include'})
            .then(response => checkStatus(response, 'Failed to fetch aggregate performance'))
            .then(response => {
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch({type: FETCH_MONTH_TO_DATE_PERFORMANCE_FAILED});
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (response) {
                    let spend = response.data.summary.cost,
                        clicks = response.data.summary.clicks,
                        impressions = response.data.summary.impressions;
                    response = {
                        spend: spend,
                        clicks: clicks,
                        impressions: impressions
                    };
                    dispatch(receiveMonthToDatePerformance(response));
                }
            }).catch(function(error) {
                Raven.captureException(error);
            });
    };
}

export function fetchNotifications(advertisableEid) {
    return dispatch => {
        return window.fetch(`${process.env.API_URL}/api/v1/rakuten/notifications?advertisable=${advertisableEid}`, {credentials: 'include'})
            .then(response => checkStatus(response, 'Failed to fetch notifications for ' + advertisableEid))
            .then(response => {
                return response.json();
            })
            .then(data => {
                dispatch(receiveNotifications(data.results.response));
                dispatch(finishedLoadingNotifications());
            })
            .catch(function(error) {
                Raven.captureException(error);
                dispatch(receiveNotifications([]));
                dispatch(finishedLoadingNotifications());
            });
    };
}

export function clearMonthToDatePerformance() {
    return dispatch => dispatch(receiveMonthToDatePerformance(null));
}

function sortDailyPerformance() {
    return (dispatch, getState) => {
        const {reportingSort, dailyPerformance} = getState();
        let newPerformance = dailyPerformance.slice(),
            direction, accessor, key;
        ({direction, accessor, key} = reportingSort);
        if (direction === '' && key === '' && accessor === null) { // The default case is to always sort by date descending
            direction = 'asc';
            accessor = function(item) { return item.date.getTime(); };
        }
        newPerformance.sort((lhs, rhs) => {
            if (direction === 'asc') {
                return accessor(lhs) <= accessor(rhs) ? -1 : 1;
            }
            return accessor(lhs) <= accessor(rhs) ? 1 : -1;
        });
        dispatch(setDailyPerformance(newPerformance));
    };
}

export function setReportingSort(sort) {
    return (dispatch) => {
        dispatch(setReportingSortAction(sort));
        dispatch(sortDailyPerformance());
    };
}

export function showSaveModal() {
    return {
        type: SHOW_SAVE_MODAL,
        value: true
    };
}

export function hideSaveModal() {
    return {
        type: SHOW_SAVE_MODAL,
        value: false
    };
}

export function fetchDailyAttributions() {
    return (dispatch, getState) => {
        const { strategy, reportingStartDate, reportingEndDate } = getState();
        let today = moment.utc().startOf('day');
        // Uhura's end date is exclusive while the one in UI is inclusive, so we need increment the one from UI by one.
        let actualEndDate = moment.utc(reportingEndDate).add(1, 'days');
        if (reportingStartDate.isAfter(today) || reportingStartDate.isSameOrAfter(actualEndDate)) {
            return dispatch(receiveDailyAttributions({}));
        }
        return window.fetch(`${process.env.API_URL}/uhura/v1/external-attributions/rakuten/advertisable?start_date=${i18n.moment(reportingStartDate).format('YYYY-MM-DD')}&end_date=${i18n.moment(actualEndDate).format('YYYY-MM-DD')}&advertisable_eid=${strategy.advertisable_eid}&breakdowns=date&currency=JPY&attribution_window=720&version=v2`,
                            {credentials: 'include'})
            .then(response => checkStatus(response, 'Failed to fetch daily attribution'))
            .then(response => {
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch({type: FETCH_DAILY_ATTRIBUTIONS_FAILED});
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (response) {
                    let results = {};
                    for (let i in response.results.date) {
                        response.results.date[i].date = new Date(response.results.date[i].date);
                        response.results.date[i].eid = response.results.date[i].date.getTime().toString();
                        results[response.results.date[i].eid] = response.results.date[i];
                    }
                    dispatch(receiveDailyAttributions(results));
                }
            }).catch(function(error) {
                Raven.captureException(error);
            });
    };
}

export function fetchAggregateAttributions() {
    return (dispatch, getState) => {
        const { strategy, reportingStartDate, reportingEndDate } = getState();
        let today = moment.utc().startOf('day');
        // Uhura's end date is exclusive while the one in UI is inclusive, so we need increment the one from UI by one.
        let actualEndDate = moment.utc(reportingEndDate).add(1, 'days');
        if (reportingStartDate.isAfter(today) || reportingStartDate.isSameOrAfter(actualEndDate)) {
            return dispatch(receiveAggregateAttributions({}));
        }
        return window.fetch(`${process.env.API_URL}/uhura/v1/external-attributions/rakuten/advertisable?start_date=${i18n.moment(reportingStartDate).format('YYYY-MM-DD')}&end_date=${i18n.moment(actualEndDate).format('YYYY-MM-DD')}&advertisable_eid=${strategy.advertisable_eid}&breakdowns=date&currency=JPY&attribution_window=720&version=v2`,
                            {credentials: 'include'})
            .then(response => checkStatus(response, 'Failed to fetch aggregate attribution'))
            .then(response => {
                if (response.status === 404 || response.url.endsWith('404')) {
                    dispatch({type: FETCH_AGGREGATE_ATTRIBUTIONS_FAILED});
                    return null;
                }
                return response.json();
            })
            .then(response => {
                if (response) {
                    let cutoffDate = getConversionDataCutoffDate(); // get cutoff date that we will use to filter out rows
                    let rows = response.results.date; // date is an array
                    let validRows = filterByCutoffDate(rows, cutoffDate);

                    // now use the remaining rows to produce a summary
                    let summary = {
                        view_throughs: 0,
                        click_throughs: 0,
                        view_revenue: 0,
                        click_revenue: 0
                    };

                    validRows.forEach(row => {
                        summary.view_throughs += row.view_throughs;
                        summary.click_throughs += row.click_throughs;
                        summary.view_revenue += row.view_revenue;
                        summary.click_revenue += row.click_revenue;
                    });

                    dispatch(receiveAggregateAttributions(summary));
                }
            }).catch(function(error) {
                Raven.captureException(error);
            });
    };
}

function checkStatus(response, errorContext) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    let error = new Error('API call failed: ' + errorContext + '. Error: ' + response.statusText);
    error.response = response;
    throw error;
}

export function saveSurvey(advertisableEid, surveyAnswers) {
    return () => {
        let form = new FormData();
        form.append('advertisable', advertisableEid);
        form.append('answers', JSON.stringify(surveyAnswers));

        let options = {
            method: 'POST',
            credentials: 'include',
            headers: _getFormPostHeaders(),
            body: form
        };

        return window.fetch(`${process.env.API_URL}/api/v1/survey/submit`, options)
            .then(response => checkStatus(response, 'Failed to save survey'))
            .then(response => {
                return response.json();
            })
            .catch(function(error) {
                Raven.captureException(error);
            });
    };
}
